import(/* webpackMode: "eager" */ "/app/app/[lng]/signup/page.tsx");
